import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { GameHelpendeGedachten, GameHelpendeGedachtenOption, HelpendeGedachtenOptionType } from '../../_models/model';
import { GameService } from '../../services/game.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AudioPlayerService } from '../../services/audio-player.service';
import { SafeHtml } from '@angular/platform-browser';
import { IProgressBarOption } from '../../sharedComponents/progress-bar/progress-bar.component';
import { IGameComponent } from '../game/game.component';

@Component({
  selector: 'app-game-helping-thoughts',
  templateUrl: './game-helping-thoughts.component.html',
  styleUrls: ['./game-helping-thoughts.component.less']
})
export class GameHelpingThoughtsComponent implements OnInit, IGameComponent<GameHelpendeGedachten> {
  enableEndIntro = false;
  @Output() closeEvent = new EventEmitter<boolean>();
  private activeGame?: GameHelpendeGedachten;
  private activeOption?: GameHelpendeGedachtenOption;

  private retryMode = false;
  public endTextShown = false;
  public endText: string = '';

  // TODO: store progress data to send for levelProgress object
  private progressData = 'd';

  // Bindable properties
  public activeOptionId = 0;
  public questionText: string = '';
  public option?: HelpendeGedachtenOptionType;
  // need to be initialized to reserve space
  public feedbackText = 'd';
  public showFootnote = false;
  public enableNextButton = false;
  public showIntro = true;
  public showingIntro = false;
  public introText?: SafeHtml;
  public showAnswers = false;
  public buttonCaption = this.audio.text.global.continue;
  public disableOptions: boolean = false;
  public helpingOptionSelected: boolean = false;
  public notHelpingOptionSelected: boolean = false;


  // Used to indicate the progress
  public progressBarData: IProgressBarOption[] = [];

  constructor(
    private gameService: GameService,
    public audio: AudioPlayerService,
    private _changeDetectionRef: ChangeDetectorRef) {
  }

  public setGame(game: GameHelpendeGedachten) {
    this.activeGame = game;
    this.introText = this.audio.getPlayAudioHTML(this.activeGame.introText, () => {
      this.enableEndIntro = true;
    });
    setTimeout(() => {
      this.enableEndIntro = true;
      // this._changeDetectionRef.detectChanges();
    }, 1000);

    this.activeOptionId = 0;
    this.activeOption = game.options[0];
    // Used to indicate the progress
    for (let optionId = 0; optionId < this.activeGame.options.length; optionId++) {
      this.progressBarData.push({ id: optionId, open: true, state: null });
    }
    // tslint:disable-next-line:max-line-length
    // See https://blog.angularindepth.com/everything-you-need-to-know-about-the-expressionchangedafterithasbeencheckederror-error-e3fd9ce7dbb4
    this._changeDetectionRef.detectChanges();
  }

  selectAnswer(answer: HelpendeGedachtenOptionType) {
    if (!this.activeGame) {
      throw Error('no active game');
    }
    this.audio.stop();

    if (answer !== this.activeOption?.type) {
      this.progressBarData[this.activeOptionId].correct = false;
      this.progressBarData[this.activeOptionId].state = 'wrong';
      this.audio.playError();
    } else {
      this.progressBarData[this.activeOptionId].correct = true;
      this.progressBarData[this.activeOptionId].state = 'good';
      this.audio.playSuccess();
    }

    // Not open anymore
    this.progressBarData[this.activeOptionId].open = false;
    this.disableOptions = true;

    if (answer === 'nothelping') {
      this.notHelpingOptionSelected = true;
      this.helpingOptionSelected = false;
    } else {
      this.notHelpingOptionSelected = false;
      this.helpingOptionSelected = true;
    }


    if (this.activeOptionId >= (this.activeGame.options.length - 1)) {
      // finished
      this.showFootnote = true;

      if (this.isFinished()) {
        this.feedbackText = this.audio.getPlay('helpende_gedachten_goed', () => {
          this.enableNextButton = true;
        });
      }
      else {
        this.feedbackText = this.audio.getPlay('helpende_gedachten_fout', () => {
          this.enableNextButton = true;
        });
      }
    }

    setTimeout(() => {
      this.enableNextButton = true;
    }, 600);
  }

  showTheAnswers() {
    this.showAnswers = true;
  }

  isFinished(): boolean {
    return this.progressBarData.every(option => option.correct === true);
  }

  endGame(): void {
    if (!this.activeGame) {
      throw Error('no active game');
    }
    this.gameService.setLevelProgress(this.activeGame.levelElement.uuid, this.progressData, true);
    this.closeEvent.emit();
  }

  setNextQuestion() {
    if (!this.activeGame) {
      throw Error('no active game');
    }
    if (this.showingIntro) {
      this.audio.stop();
      this.showingIntro = false;
      this.showQuestion(false);
      return;
    }

    // Check if end of all answers
    if (this.isFinished()) {
      this.endGame();
      return;
    }

    // Go to first
    if (this.activeOptionId >= (this.activeGame.options.length - 1)) {
      this.activeOptionId = 0;
      this.retryMode = true;
    } else {
      this.activeOptionId++;
    }

    // einde bereikt --> check if finished
    // Check if all answers are correct, if so, end game.
    // If there are still unanswered question, start at beginning.

    if (this.retryMode) {
      // Find next option
      while (this.progressBarData[this.activeOptionId].correct === true) {
        if (this.activeOptionId >= (this.activeGame.options.length - 1)) {
          this.activeOptionId = 0;
        } else {
          this.activeOptionId++;
        }
      }
      this.progressBarData[this.activeOptionId].state = null;
    }

    this.feedbackText = 'd';
    this.showFootnote = false;
    this.enableNextButton = false;
    this.showQuestion();
  }

  showQuestion(playExplanationText = false) {
    if (!this.activeGame) {
      throw Error('no active game');
    }
    this.activeOption = this.activeGame.options[this.activeOptionId];
    this.questionText = this.activeOption.question.text;
    // this.feedbackText = this.activeOption.feedback.text;
    this.option = this.activeOption.type;
    this.showFootnote = false;
    this.enableNextButton = false;
    this.showAnswers = false;
    this.disableOptions = true;
    this.notHelpingOptionSelected = false;
    this.helpingOptionSelected = false;
    if (playExplanationText) {
      const activeOption = this.activeOption;
      this.audio.play('helpende_gedachten_uitleg', () => {
        if (!activeOption) {
          throw Error('no active option');
        }
        this.audio.playAudio(activeOption.question, _ => {
          this.showAnswers = true;
          this.disableOptions = false;
          this.notHelpingOptionSelected = false;
          this.helpingOptionSelected = false;
        });

      });
      setTimeout(() => {
        this.enableNextButton = true;
      }, 1000);
    } else {
      this.audio.playAudio(this.activeOption.question, _ => {
        this.showAnswers = true;
        this.disableOptions = false;
        this.notHelpingOptionSelected = false;
        this.helpingOptionSelected = false;
      });
      setTimeout(() => {

        this.disableOptions = false;
      }, 1000);

    }


  }

  introNext() {
    this.audio.stop();
    this.showingIntro = true;
    this.showIntro = false;
    this.showQuestion(true);
  }

  ngOnInit(): void {

  }

}
